import React from 'react';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Tooltip } from 'primereact/tooltip';
import { groupChatsByDate, getChatIcon } from '../utils/chatUtils';

const ChatList = ({ chats, unreadMessages, activeChat, onChatSelect, markChatAsRead }) => {
    const renderChatItem = (chat) => {
        const messageStatus = unreadMessages[chat.id] || {};
        const isActive = activeChat === chat.id;
        const isBuzzed = messageStatus.buzzed && messageStatus.buzzTimestamp &&
            (new Date().getTime() - messageStatus.buzzTimestamp.toDate().getTime()) < 5000;

        const chatName = chat.tag?.includes('Changed nickname')
            ? `${chat.tag}`
            : chat.shopperName
                ? `${chat.shopperName}`
                : 'Chat with Shopper';

        return (
            <div
                key={chat.id}
                onClick={() => {
                    // Toggle chat selection
                    if (activeChat === chat.id) {
                        // If same chat is clicked, deselect it
                        onChatSelect(null);
                    } else {
                        // If different chat is clicked, select it
                        onChatSelect(chat.id);
                        if (messageStatus.hasUnread) {
                            markChatAsRead(chat.id);
                        }
                    }
                }}
                className={`chat-item 
          ${chat.closed ? 'chat-item-disabled' : ''} 
          ${messageStatus.hasUnread ? 'chat-item-unread' : ''}
          ${chat.tag !== 'Spam' && isBuzzed ? 'chat-item-buzzed' : ''}
          ${isActive ? 'chat-item-active' : ''}
          ${!chat.closed ? 'chat-item-hover' : ''}`}
                disabled={chat.closed}
            >
                <div className="chat-item-content">
                    <span className={`${getChatIcon(chat.tag)} chat-icon`}></span>
                    <div className="chat-item-details">
                        <h4 className="chat-name" data-pr-tooltip={chat?.tag?.includes("Changed nickname") ? chat?.tag : chatName}>
                            {chat?.tag?.includes("Changed nickname") ? chat?.tag : chatName}
                        </h4>
                        {chat.tag !== 'Spam' && messageStatus.hasUnread && !isActive && <span className="unread-badge"></span>}
                    </div>
                </div>
                <Tooltip target=".chat-name" mouseTrack mouseTrackLeft={10} />
            </div>
        );
    };

    return (
        <ScrollPanel className="chat-scroll-panel">
            <div className="chat-sidebar">
                {Object.entries(groupChatsByDate(chats)).map(([date, chats]) => (
                    <div key={date} className="chat-group">
                        <div className={`chat-date-header ${date === 'Today' ? 'today' : ''}`}>
                            {date}
                        </div>
                        {chats.map(renderChatItem)}
                    </div>
                ))}
            </div>
        </ScrollPanel>
    );
};

export default ChatList; 